import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Trophy02 = function Trophy02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 17c-3.5898 0-6.5-2.9101-6.5-6.5V4.5556c0-.5182 0-.7773.0937-.9782a1 1 0 0 1 .4837-.4837C6.2784 3 6.5374 3 7.0556 3h9.8888c.5182 0 .7773 0 .9782.0937a1 1 0 0 1 .4837.4837c.0937.201.0937.46.0937.9782V10.5c0 3.5899-2.9101 6.5-6.5 6.5m0 0v4m5 0H7M22 5v5M2 5v5"
    })
  }));
};
export default Trophy02;